import { MealSectionContent, StyledMealSection } from "./styled"
import DiaryMealItem from "./MealItem"
import { MealType } from "model/food/types"

interface IMealSectionProps {
  meals: MealType[]
  swipedId: string | null
  setSwipedId: (id: string | null) => void
}

const MealSection = (props: IMealSectionProps) => {
  const { meals, swipedId, setSwipedId } = props

  return (
    <StyledMealSection>
      <MealSectionContent>
        {meals.map((meal) => (
          <DiaryMealItem
            meal={meal}
            key={meal.id}
            swipedId={swipedId}
            setSwipedId={setSwipedId}
          />
        ))}
      </MealSectionContent>
    </StyledMealSection>
  )
}

export default MealSection
